import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useGetByIdLink } from '../../../../app/hooks/useGetByIdLink'
import { useGetChartLink } from '../../../../app/hooks/useGetChartLink'
import { useTransactions } from '../../../../app/hooks/useTransactions'

const useLinkDetailsController = () => {
  const { id: linkId } = useParams()

  const { data: linkData, isLoading: isLoadingLink } = useGetByIdLink({
    linkId: linkId || '',
    enabled: !!linkId,
  })

  const { data: chartData, isLoading: isLoadingChart } = useGetChartLink({
    linkId: linkId || '',
    enabled: !!linkId,
  })

  const {
    data: transactionsData,
    isLoading: isLoadingTransactions,
    setParams,
  } = useTransactions({ interval: false })

  useEffect(() => {
    if (linkId) {
      setParams({
        linkId,
      })
    }
  }, [linkId, setParams])

  const statistics = transactionsData?.statitics
  const contracts = statistics?.total || 0
  const totalValue = statistics?.total_value || 0

  const simulations = linkData?.simulations_count || 0

  const chartEntries = chartData?.data || []
  const totalAccesses = chartData?.total || 0

  const allTransactions = transactionsData?.transactions || []

  const getPageIndex = () => {
    if (!transactionsData) return 0
    return (
      Math.floor(
        transactionsData.pagination.skip / transactionsData.pagination.limit,
      ) + 1
    )
  }

  const getPageCount = () => {
    if (!transactionsData) return 0
    return Math.ceil(
      transactionsData.pagination.total / transactionsData.pagination.limit,
    )
  }

  const handleNextPage = () => {
    if (!transactionsData) return
    const newPage =
      transactionsData.pagination.skip / transactionsData.pagination.limit + 1
    if (getPageCount() === getPageIndex()) return
    const skipValue = newPage * transactionsData.pagination.limit
    setParams({ skip: skipValue })
  }

  const handlePreviousPage = () => {
    if (!transactionsData) return
    const newPage =
      transactionsData.pagination.skip / transactionsData.pagination.limit - 1
    if (newPage < 0) return
    const skipValue = newPage * transactionsData.pagination.limit
    setParams({ skip: skipValue })
  }

  return {
    linkData,
    simulations,
    chartData,
    chartEntries,
    totalAccesses,
    transactionsData,
    allTransactions,
    contracts,
    totalValue,
    handleNextPage,
    handlePreviousPage,
    getPageCount,
    getPageIndex,
    isLoadingLink,
    isLoadingChart,
    isLoadingTransactions,
    isLoading: isLoadingLink || isLoadingChart || isLoadingTransactions,
  }
}

export default useLinkDetailsController
